<template>
  <div id="search-results" :class="hide ? 'hide' : ''">
    <ul class="row list-unstyle">
      <template v-for="(item, index) in filteredResults">

          <li v-if="index < 4" :key="`recommended-${index}`" class="col-sm-6 col-md-6 has-mb-4 filter-item">
            <RecommendedCard
                :heading="item.heading"
                :link="item.headingHref"
                :image="item.image"
                :text="item.text.substring(0, 300) + '...'"
                :tags="item.tags"
                :icon="item.icon"
                :category="item.category"
                :categoryRank="item.categoryRankSortable"
                :importance="item.importanceSortable" />
          </li>

          <li v-else :key="`recommended-${index}`" class="col-sm-6 col-md-6 has-mb-4 filter-item">
            <RecommendedText
                :heading="item.heading"
                :link="item.headingHref"
                :text="item.text"
                :category="item.category"
                :categoryRank="item.categoryRankSortable"
                :importance="item.importanceSortable" />                
          </li>

      </template>
    </ul>
  </div>
</template>

<script>
import $ from "webpack-zepto";  
import RecommendedCard from "../recommended/RecommendedCard";
import RecommendedText from "../recommended/RecommendedText";

export default {
  name: "Recommended",
  components: {
    RecommendedCard,
    RecommendedText
  },
  data: function () {
    return {
      hide: false,
    }
  },
  computed: {
    filteredResults: function () {
      return this.$store.state.filteredResults;
    },
    filter: function (){
      return this.$store.state.filter;
    }
  },
  created() {
    this.hide = true;
  },  
  mounted() {    
    setTimeout(() => { 
      this.hide = false; 
    }, 500);
  },
  updated() {
    $(document).trigger('SearchAppUpdated');
  },  
}
</script>
<style>
    #search-results.hide {
      opacity: 0;
    }
    #search-results {
      opacity: 1;
      transition: opacity 0.5s;
    }
    .search-debug {
      margin: -12px 0px 8px; color: #ff0000;
      display: none;
      font-size: 0.7em;
    }
    .debug-mode .search-debug {
      display: block;
    }      
</style>